/**
 * useCompany Hook
 * 
 * Provides access to company context
 * Wrapper around useCompany from CompanyContext for consistent imports
 */

import { useCompany as useCompanyContext } from '@/contexts/CompanyContext';

/**
 * Hook to access company configuration and data
 * 
 * @returns Company context with configuration and data
 * @throws Error if used outside CompanyProvider
 */
export function useCompany() {
  return useCompanyContext();
}
